$(document).ready(function() {
  // Check if the URL contains '/tagged/'
  if (window.location.href.indexOf('/tagged/') !== -1) {
    $('body').addClass('tagged_page');
  }
});

$('.testimonials-slider').owlCarousel({
    loop:false,
    margin:0,
    nav:true,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
}) ;

$(document).ready(function() {
    $('.product_faqs_row .accordion-header').click(function() {
        $(this).next('.product_faqs_row .accordion-content').slideToggle();
        $('.product_faqs_row .accordion-content').not($(this).next()).slideUp();
        $(this).toggleClass('active');
        $('.product_faqs_row .accordion-header').not($(this)).removeClass('active');
    });
});

$('.facets__item').click( function(){
  $('.facets-vertical .active-facets').addClass('active');
}); 
$('.active-facets__button-remove').click( function(){
  $('.facets-vertical .active-facets').removeClass('active');
}); 


// Cart page add Gift Wrap
document.getElementById('gift-wrap-checkbox').addEventListener('change', function () {
  const giftWrapMessage = document.getElementById('gift-wrap-message');

  if (this.checked) {
    // Add gift wrap product to the cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          quantity: 1,
          // id: '49507859431720' // Replace with the actual variant ID of the gift wrap product
          id: '50631080837416' // Replace with the actual variant ID of the gift wrap product
        }]
      })
    }).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    }).then(data => {
      console.log('Gift wrap added:', data);

      // Display success message
      let messageDiv;
      if (!giftWrapMessage) {
        messageDiv = document.createElement('div');
        messageDiv.id = 'gift-wrap-message';
        document.querySelector('.gift_wraping').after(messageDiv);
      } else {
        messageDiv = giftWrapMessage;
      }

      messageDiv.textContent = 'Gift wrap added';
      messageDiv.className = 'added';

      setTimeout(() => {
        messageDiv.remove();
      }, 4000);
    }).catch(error => {
      console.error('Error adding gift wrap:', error);
    });
  } else {
    // Remove gift wrap product from the cart
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: '50631080837416', // Replace with the actual variant ID of the gift wrap product
        quantity: 0
      })
    }).then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    }).then(data => {
      console.log('Gift wrap removed:', data);

      // Display removal message
      let messageDiv;
      if (!giftWrapMessage) {
        messageDiv = document.createElement('div');
        messageDiv.id = 'gift-wrap-message';
        document.querySelector('.gift_wraping').after(messageDiv);
      } else {
        messageDiv = giftWrapMessage;
      }

      messageDiv.textContent = 'Gift wrap removed';
      messageDiv.className = 'removed';

      setTimeout(() => {
        messageDiv.remove();
      }, 4000);
    }).catch(error => {
      console.error('Error removing gift wrap:', error);
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const giftWrapCheckbox = document.getElementById('gift-wrap-checkbox');
  const cartNote = document.querySelector('.cart__note');

  // Restore checkbox state from localStorage
  const isGiftWrapAdded = localStorage.getItem('giftWrapAdded') === 'true';
  giftWrapCheckbox.checked = isGiftWrapAdded;

  // Show/hide cart__note based on checkbox state
  if (isGiftWrapAdded) {
    cartNote.style.display = 'block';
  } else {
    cartNote.style.display = 'none';
  }

  giftWrapCheckbox.addEventListener('click', function () {
    const isChecked = this.checked;

    if (isChecked) {
      // Add gift wrap product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            quantity: 1,
            id: '50631080837416' // Replace with the actual variant ID of the gift wrap product
          }]
        })
      }).then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      }).then(data => {
        console.log('Gift wrap added:', data);
        localStorage.setItem('giftWrapAdded', 'true'); // Store checked state
        cartNote.style.display = 'block'; // Show cart note
        location.reload(); // Reload the page
      }).catch(error => {
        console.error('Error adding gift wrap:', error);
      });
    } else {
      // Remove gift wrap product from the cart
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: '50631080837416', // Replace with the actual variant ID of the gift wrap product
          quantity: 0
        })
      }).then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      }).then(data => {
        console.log('Gift wrap removed:', data);
        localStorage.setItem('giftWrapAdded', 'false'); // Store unchecked state
        cartNote.style.display = 'none'; // Hide cart note
        location.reload(); // Reload the page
      }).catch(error => {
        console.error('Error removing gift wrap:', error);
      });
    }
  });
});





// function toggleJoinButton() {
//     const checkbox = document.getElementById('termsCheckbox');
//     const joinButton = document.getElementById('joinButton');
    
//     if (checkbox.checked) {
//         joinButton.style.pointerEvents = 'auto';
//         joinButton.style.opacity = '1';
//     } else {
//         joinButton.style.pointerEvents = 'none';
//         joinButton.style.opacity = '0.8';
//     }
// }


$(document).ready(function() {
    $('#termsCheckbox').on('change', function() {
        const isChecked = $(this).is(':checked');
        const $joinButton = $('#joinButton');
        if (isChecked) {
            $joinButton.css({
                'pointer-events': 'auto',
                'opacity': '1',
                'color': '#007bff'
            });
        } else {
            $joinButton.css({
                'pointer-events': 'none',
                'opacity': '0.8',
                'color': '#aecdd2'
            });
        }
    });
});


// document.getElementById('gift-wrap-checkbox').addEventListener('change', function() {
//   let variantId = '48930870264104'; // Replace with the actual variant ID of the gift wrap product
//   let url = this.checked ? '/cart/add.js' : '/cart/change.js';
//   let method = 'POST';
//   let body = this.checked ? 
//   JSON.stringify({ items: [{ quantity: 1, id: variantId }] }) : 
//   JSON.stringify({ id: variantId, quantity: 0 });

//   fetch(url, {
//     method: method,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: body
//   })
//   .then(response => {
//     if (!response.ok) {
//       return response.json().then(error => { throw new Error(error.description); });
//     }
//     return response.json();
//   })
//   .then(data => {
//     console.log('Cart updated:', data);
//     location.reload(); // Reload the page to update the cart display
//   })
//   .catch(error => {
//     console.error('Error updating cart:', error);
//     alert('There was an error while updating your cart. Please try again.');
//   });
// });
 
